/*
  This mixin added focus style to needed element(tabNavigationStartElement), at first tab keydown
*/

export default {
    data: () => ({
        isFirstTabKeydown: true
    }),
    methods: {
        changeTabNavigation (e) {
            if(this.isFirstTabKeydown && e.code === 'Tab') {
                e.preventDefault()
                this.isFirstTabKeydown = false
                document.querySelector(this.tabNavigationStartElement).focus()
            }
        }
    },
    created() {
        document.addEventListener('keydown', this.changeTabNavigation);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.changeTabNavigation);
    }
}